<template>
  <div :class="['upload-img', {'upload-img-submit': toSubmit}, `${page_style}`]">
    <div class="content-wrapper">
      <div class="upload-img-header" @click="showScale">
        <div
          v-show="field_status != 6 && field_result && showTip"
          class="tips"
          :class="[{success: isSuccess, checking: isNew || isIng, error: isFailed}]"
        >{{field_result}}</div>
        <img-v3 :src="uploadImgSrc ? success_pic : exam_pic" :class="{widthImg: pic_type == 1, heightImg: pic_type == 2, examImg: true}" />
      </div>
      <div class="upload-img-content">
        <p class="content-title">{{sample.title}}</p>
        <div class="content-p-wrapper">
          <p class="content-p" v-for="(t,idx) in sample.content" :key="idx" v-html="t"></p>
        </div>
      </div>
    </div>
    <!-- 上传成功态，隐藏底部按钮 -->
    <div class="upload-input-wrapper" v-show="!hideBottom">
      <div class="out-upload-input" v-if="!toSubmit" :style="isNew ? uploadBtnStyle : reUploadBtnStyle">
        <template v-if="inApp">
          <input type="button" @click="selectImg" />
          {{isNew ? uploadBtn.un_check.title: uploadBtn.is_check.title}}
        </template>
        <template v-else>
          <!-- <input id="photo" type="file" accept="image/*" /> -->
          <input id="photo" type="file" accept="application/pdf" />
          {{isNew ? uploadBtn.un_check.title: uploadBtn.is_check.title}}
        </template>
      </div>
      <div class="bottom-area" v-else-if="!formItem.is_ocr && toSubmit">
        <!-- <a class="btn-submit" @click="uploadImg" :style="canSubmit ? active_submit_style : disabled_submit_style">{{submitBtn.is_check.title}}</a> -->
        <a class="btn-reUpload" @click="clearImg" :style="reset_btn_style">{{resetBtn.un_check.title}}</a>
      </div>
    </div>
    <scale ref="scaleRef" :img-url="exam_pic" v-if="!toSubmit"></scale>
    <ocr
      :ocr_config="formItem.ocr_config"
      :job_type="formItem.job_type"
      :job_uid="formItem.job_uid"
      :form_key="formItem.key"
      :radio_type_key="formItem.radio_type_key"
      :radio_type_value="formItem.radio_type_value"
      :show_ocr="show_ocr"
      :ocr_img="ocr_img"
      :submit_btn="submitBtn"
      :reset_btn="resetBtn"
      v-show="show_ocr"
      @closeOcr="closeOcr"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import scale from "./Scale";
import ocr from "./Ocr";
import { pdfReader } from "../../tools/utils";
import { post } from "../../tools/request";
import { showLoadingToast, showAlertDialog, showToast } from "../../tools/Tip";

const AUDIT_STATUS = {
  in: 3,
  success: 4,
  fail: 5,
  noSubmit: 0,
  beforeUpdate: 6
};

export default {
  name: "upload-pdf",
  components: { scale, ocr },
  data() {
    return {
      toSubmit: false, //页面模块控制
      canSubmit: false, //提交按钮控制,
      showTip: true, //默认为true，点击重新上传后不再展示
      uploadImgSrc: "",
      uploadStart: 0,
      originSize: 0,
      compressedSize: 0,
      show_ocr: false,
      ocr_img: "",
      b2md5: null,
      store_result: null
    };
  },
  props: ['dialogStyle', 'auditConfig'],
  computed: {
    ...mapState(["_ticket", "_uuid"]),
    AUDIT_STATUS() {
      return AUDIT_STATUS;
    },
    page_style() {
      return this.$route.params.page_style || this.dialogStyle;
    },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    //传递过来整个对象
    formItem() {
      let c = this.isFleetPCFunnel ? this.auditConfig : this.$route.params.configs;
      return c || {};
    },
    exam_pic() {
      return (this.formItem.exam_pic_url || [])[0];
    },
    success_pic() {
      return (this.formItem.exam_pdf_success_pic_url || [])[0];
    },
    pic_type() {
      return this.formItem.exam_pic_type || 1;
    },
    sample() {
      return this.formItem.pic_desc || {};
    },
    field_status() {
      return this.formItem.field_status || 0;
    },
    field_result() {
      return this.formItem.field_result || "";
    },
    inApp() {
      return !!Fusion.pickImage;
    },
    isNew() {
      return this.field_status == AUDIT_STATUS.noSubmit;
    },
    isIng() {
      return this.field_status == AUDIT_STATUS.in;
    },
    isSuccess() {
      return this.field_status == AUDIT_STATUS.success;
    },
    isFailed() {
      return this.formItem.field_status == AUDIT_STATUS.fail;
    },
    //上传成功态，隐藏底部按钮
    hideBottom() {
      return this.isSuccess;
    },
    uploadBtn() {
      return (this.formItem.upload_button_color || {}).button_color || { un_check: {}, is_check: {} };
    },
    submitBtn() {
      return (this.formItem.submit_button_color || {}).button_color || { un_check: {}, is_check: {} };
    },
    resetBtn() {
      return (this.formItem.reset_button_color || {}).button_color || { un_check: {}, is_check: {} };
    },
    uploadBtnStyle() { // 第一次上传
      let btnColor = this.uploadBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border || 'none'
      }
    },
    reUploadBtnStyle() { // 审核中和审核失败重新上传
      let btnColor = this.uploadBtn.is_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
        border: btnColor.border
      }
    },
    disabled_submit_style() {
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    active_submit_style() {
      let btnColor = this.submitBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    reset_btn_style() {
      let btnColor = this.resetBtn.un_check;
      return {
        color: btnColor.text_color,
        background: btnColor.background_color,
      }
    },
    document_enum() {
      return this.formItem.document_enum || "";
    }
  },
  watch: {
    toSubmit(newVal) {
      if (!newVal) {
        //切回重新选择的页面时，再次赋值
        this.$nextTick(() => this.initOutUpload());
      }
    }
  },

  beforeCreate() {
    //一旦进入上传页，返回按钮就正常返回
    Fusion.resetBack &&
      Fusion.resetBack({
        reset: 2
      });
  },
  created() {
    //非nosubmit，展示上传区域、传过的图片
    if (
      this.field_status != AUDIT_STATUS.noSubmit &&
      this.field_status != AUDIT_STATUS.beforeUpdate
    ) {
      // this.toSubmit = true;
      this.uploadImgSrc = this.formItem.value[0] || "";
    }
  },
  mounted() {
    this.initOutUpload();
  },
  methods: {
    closeOcr() {
      this.show_ocr = false;
      this.clearImg();
    },
    showScale() {
      if (this.$refs.scaleRef) {
        this.$refs.scaleRef.show();
      }
    },
    initOutUpload() {
      //端外使用input上传
      if (!this.inApp) {
        const photoBtn = document.getElementById("photo");
        pdfReader(photoBtn, this.handleAfterChoose, this.handleImageError);
      }
    },
    //采用澳洲方案，先传图片，再提审
    uploadImg() {
      if (!this.formItem.is_ocr && !this.canSubmit) {
        return
      }
      this.uploadStart = +new Date();
      showLoadingToast(this);
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      let success = data => {
        this.toast.hide();
        if (data.low_quality_res && data.low_quality_res === 1) {
          showAlertDialog(this, data.low_quality_des);
          return false;
        }
        this.submitImg(data.img_id);
        try {
          if (this.b2md5 && !this.store_result) {
            //后半段判断，防止多次选择同一图片后，重复的set操作
            window.localStorage.setItem(this.b2md5, data.img_id);
          }
          Omega.trackEvent("ibt_crl_pdf_success_bt");
        } catch (e) {}
      };
      if (this.store_result) {
        success({ img_id: this.store_result });
        return;
      }
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.formItem.key);
      up.append("document_enum", this.document_enum);

      post(process.env.UPLOAD_IMG, up)
        .then(success)
        .catch(this.httpError);
    },
    submitImg(url) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }

      // @200922 多种类型上传组件, 外层透传radio选择类型 key,value
      if (this.formItem.radio_type_key) {
        up.append(this.formItem.radio_type_key, this.formItem.radio_type_value);
      }

      if (this.formItem.is_ocr) {
        up.set("sPicUrl", url);
        this.ocr_img = url;
        let config = this.formItem.ocr_config;
        post(config.url, up)
          .then(data => {
            let keys = Object.keys(data);
            //formItem 中的ocr_config 做对比，赋值
            keys.forEach(item => {
              let finded = config.form.filter(x => x.key === item);
              if (finded.length) {
                finded[0].value = data[item];
              }
            });
            this.show_ocr = true;
          })
          .catch(err => showAlertDialog(this, err.errmsg || this.$t("ERROR_DEFAULT_TEXT")))
          .finally(() => {
            this.toast.hide();
          });
        return;
      }
      up.append(this.formItem.key, JSON.stringify([url]));
      // @20190213 支持任务中心,type|uid
      if (this.formItem.job_type) {
        up.append("job_type", this.formItem.job_type);
      }
      if (this.formItem.job_uid) {
        up.append("job_uid", this.formItem.job_uid);
      }
      let success = data => {
        // 证件列表页加toast
        if (['photoInfoNewBr', 'photoInfoNewAu', 'photoInfoNewMx', 'history'].includes(this.$route.params.page_route)) {
          showToast(this, {
            type: 'correct',
            txt: this.$t("GDriver_Flexibilization_oDFz_KWll")
          });
          setTimeout(() => {
            let isHistory = this.$route.params.page_route && this.$route.params.page_route == 'history';
            this.$router.replace({ name: isHistory ? "history" : 'home' });
          }, 2000);
        } else {
          this.$router.replace({ name: "home" });
        }
      };
      post(process.env.ADD_AUDI_INFO, up)
        .then(success)
        .catch(err => {
          this.httpError(err);
          try {
            Omega.trackEvent("ibt_register_submit_review_error_ck", '', {
              path_url: process.env.ADD_AUDI_INFO,  //接口url
              message: JSON.stringify(err),  //全部返回信息
              request: up.toString(),  //请求参数信息
              errno: err.errno,  //报错码
            });
          } catch (e) {}
        });

    },
    clearImg() {
      this.canSubmit = false;
      this.toSubmit = false;
      this.showTip = false;
      this.uploadImgSrc = "";
      this.b2md5 = null;
      this.store_result = null;
      this.$emit("btn-update");

    },
    selectImg() {
      // @200917 新的文件上传的bridge
      Fusion.chooseFile(
        {
          file_extension: 'application/pdf', // 文件类型 (MIME type)
          // max_size: 1024*4
        },
        ret => this.handleAfterChoose(ret)
      );
    },
    handleAfterChoose(ret) {
      // -1: 打开文件浏览失败
      // -2: 文件读取失败
      // -3: 文件过大
      // -4: 文件格式错误
      // -5: 系统版本过低,拒绝访问文件
      if (ret.errorCode != 104) {
        if (ret.errorCode === -3) {
          this.handleImageError()
        } else if (ret.errorCode === -4) {
          showAlertDialog(this, `Por favor, envie o documento em PDF`);
        } else if (ret.errorCode === -5) {
          showAlertDialog(this, `Sua versão do iOS não suporta o upload de pdf, por favor, selecione a opção de imagem ou atualize seu sistema operacional`);
        }
        return;
      }
      let imgSrc = ret.fileBase64String;

      if (this.inApp) {
        imgSrc = "data:application/pdf" + ";base64," + ret.fileBase64String;
        Omega.trackEvent("ibt_register_pdf_upload_ck");
      } else {
        Omega.trackEvent("ibt_register_h5_pdf_upload_ck");
      }
      this.uploadImgSrc = imgSrc;
      this.showTip = false; // 上传后状态重置一下
      try {
        if (window.localStorage) {
          this.b2md5 = md5(this.uploadImgSrc);
          this.store_result = window.localStorage.getItem(this.b2md5);
        }
      } catch (e) {}
      this.canSubmit = true;
      this.toSubmit = true;
      //埋点用
      this.compressedSize = imgSrc.length;
      this.originSize = ret.originSize || 0;
      //通知父级组件重新渲染
      this.$emit("btn-update");
      //@20191118 自动提交
      // if (this.formItem.is_ocr) {
        this.uploadImg();
      // }
    },
    handleImageError() {
      showAlertDialog(this, this.$t("图片尺寸过大"));
    },
    httpError(res) {
      try {

      } catch (e) {}
      this.toast.hide();
      showAlertDialog(this, this.$t("ERROR_DEFAULT_TEXT"));
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-img {
  min-height: 100%;
  box-sizing: border-box;
  padding-bottom: 2rem;
  &.upload-img-submit {
    padding-bottom: 3.08rem;
  }
  .upload-img-header {
    height: 6.12rem;
    background: #282a33;
    overflow: hidden;
    position: relative;
    .tips {
      padding: 0.36rem 0.3rem;
      color: #fff;
      font-size: 0.32rem;
      position: absolute;
      left: 0;
      top: 0;
      box-sizing: border-box;
      width: 100%;
      opacity: 0.9;
      z-index: 1;
      &.success {
        background: #18C47C;
      }
      &.error {
        background: #ff4d58;
      }
      &.checking {
        display: none;
        background: #999;
      }
    }
    // .widthImg {
    //   width: 6rem;
    //   height: 5.18rem;
    //   background-size: 6rem 5.18rem;
    // }
    // .heightImg {
    //   max-width: 6rem;
    //   height: 5.2rem;
    //   background-size: 3.84rem 5.2rem;
    // }
    .examImg {
      max-width: 80%;
      max-height: 80%;
    }
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .upload-img-content {
    text-align: center;
    padding: 0.3rem 0.32rem 0;
    .content-title {
      font-size: 0.48rem;
      color: #1f2933;
      margin-bottom: 0.24rem;
    }
    .content-p {
      text-align: left;
      font-size: 0.28rem;
      color: #949494;
      margin-bottom: 0.2rem;
      line-height: 1.1;
    }
  }

  .upload-input-wrapper {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    background: #f5f5f7;
    box-shadow: 0 -20px 20px 0 rgba(0,0,0,0.04);
    z-index: 5;
    .out-upload-input {
      position: relative;
      margin: 0.4rem auto;
      display: block;
      width: 6.8rem;
      height: 1.08rem;
      font-size: 0.32rem;
      line-height: 1.08rem;
      text-align: center;
      font-family: "HelveticaNeue-Medium";
      color: #000;
      background: #ffe600;
      border-radius: 6px;
      > input {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
      }
    }
    .bottom-area {
      padding: 0.36rem 0.32rem;

      > a {
        display: block;
        width: 6.8rem;
        height: 1.08rem;
        font-size: 0.32rem;
        line-height: 1.08rem;
        text-align: center;
        font-family: "HelveticaNeue-Medium";
        border-radius: 6px;
        box-sizing: border-box;
        &.btn-submit {
          color: #000;
          background: #ffe600;
        }
        &.btn-reUpload {
          color: #333;
          background: #fff;
          border: 1px solid #999;
        }
        &:first-child {
          margin-bottom: 0.2rem;
        }
      }
    }
  }
  &.h5_funnel_fleet,
  &.h5_funnel_fleet_pc {
    padding-bottom: 1.7rem;
    background: #ffffff;
    .upload-img-header {
      height: 4.64rem;
      background: #ffffff;
    }
    .upload-img-content {
      padding-top: 0;
      .content-title {
        margin-bottom: 0.32rem;
        line-height: 0.44rem;
        font-size: .36rem;
        color: #333333;
        font-weight: 700;
      }
      .content-p-wrapper {
        padding: 0.32rem;
        background: #FAFAFA;
        border-radius: .12rem;
        .content-p {
          font-size: .28rem;
          color: #999999;
          line-height: .4rem;
          font-weight: 400;
        }
      }
    }
    .upload-input-wrapper {
      background: #ffffff;
      box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
      .out-upload-input {
        border-radius: .2rem;
        font-weight: 700;
        font-size: 0.4rem;
        &.mx-submit {
          background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
        }
      }
    }
    .bottom-area {
      background: #FFFFFF;
      box-shadow: 0px -20px 20px 0px rgba(0,0,0,0.06);
      > a {
        width: 100%;
        box-sizing: border-box;
        border-radius: 0.2rem;
        font-weight: 700;
        font-size: 0.4rem;
      }
      a.btn-submit {
        background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
      }
    }
  }
  &.h5_funnel_fleet_pc {
    .upload-img-header {
      height: 180px;
      padding: 16px 0 32px 0;
      .examImg {
        max-width: 80%;
        max-height: 100%;
      }
    }
    .upload-img-content {
      padding: 0 40px;
      .content-title {
        margin-bottom: 16px;
        font-size: 18px;
        text-align: center;
        line-height: 22px;
        font-weight: 700;
      }
      .content-p-wrapper {
        padding: 16px;
        border-radius: 6px;
        .content-p {
          font-size: 14px;
          line-height: 20px;
          font-weight: 400;
        }
      }
    }
    .upload-input-wrapper {
      position: absolute;
      height: 80px;
      padding: 24px;
      box-shadow: none;
      text-align: right;
      .out-upload-input {
        width: auto;
        display: inline-block;
        margin: 0;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        color: #fff;
        background-image: linear-gradient(134deg, #FF7D41 0%, #FF7D41 0%, #FF964A 100%);
      }
    }
    .bottom-area {
      width: calc(100% - 48px);
      display: flex;
      justify-content: flex-start;
      flex-direction: row-reverse;
      position: absolute;
      padding: 0;
      box-shadow: none;
      text-align: right;
      > a {
        width: auto;
        display: inline-block;
        padding: 6px 16px;
        box-sizing: border-box;
        height: 32px;
        line-height: 20px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
        vertical-align: middle;
        &:first-child {
          margin-bottom: 0;
          margin-left: 12px;
        }
        &.btn-reUpload {
          color: #333;
          background: #fff;
          border: 1px solid #999;
        }
        &.btn-submit {
          color: #fff;
          background-image: linear-gradient(134deg, #FF7D41 0%, #FF7D41 0%, #FF964A 100%);
        }
      }
    }
  }
}

.reUpload-img {
  .reUpload-img-header {
    background: #282a33;
    overflow: hidden;
    position: relative;
    height: 5.88rem;
    img {
      max-width: 90%;
      height: 5.44rem;
      display: block;
      margin: 0.24rem auto;
    }

  }

}
</style>
